import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="header header-fixed" ng-click="vm.closeMenu()">
            <div class="row2">
                <div class="col00 small">
                    <div class="heading01 type01">
                        <h1>
                            <img
                                ng-if="vm.company.logoFilename"
                                ng-src="{{ vm.CompanyService.getLogoImage(vm.company.logoFilename, vm.company.id, 'smallHeaderLogo') }}"
                                height="40"
                            >
                        </h1>
                        <p class="center">{{ 'forms.Evaluatee' | translate }}<strong>{{ vm.evaluatee }}</strong></p>
                        <div class="quizdata">
                          <select class="form-control"
                                  ng-model="vm.language"
                                  ng-change="vm.changeLanguage()"
                                  ng-options="language.toLowerCase() as vm.COMPANY_LANGUAGE_ENUM.DROPDOWN_LABELS_IN_NATIVE[language]
                                              for (code, language) in vm.languages
                                              track by language.toLowerCase()">
                          </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor ($rootScope, $translate, $stateParams, FormSubmissionResource, CompanyResource, UserResource,
                 TranslationService, CompanyService,
                 FORMS_SUBMISSION_STATUS_ENUM, COMPANY_LANGUAGE_ENUM, USER_SWITCH_LANGUAGE_SOURCE_ENUM) {
        this.$translate = $translate;
        this.$rootScope = $rootScope;
        this.$stateParams = $stateParams;
        this.FormSubmissionResource = FormSubmissionResource;
        this.CompanyResource = CompanyResource;
        this.UserResource = UserResource;
        this.TranslationService = TranslationService;
        this.CompanyService = CompanyService;
        this.FORMS_SUBMISSION_STATUS_ENUM = FORMS_SUBMISSION_STATUS_ENUM;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
        this.USER_SWITCH_LANGUAGE_SOURCE_ENUM = USER_SWITCH_LANGUAGE_SOURCE_ENUM;
    }

    $onInit () {
        if (this.$rootScope.formSubmission && this.$rootScope.formSubmission.user) {
            this.language = this.$rootScope.formSubmission.user.coursyLanguage.toLowerCase();
        }
        else {
            this.language = this.$translate.use();
        }
        this.initData();
    }

    changeLanguage () {
        this.TranslationService.changeLanguage(this.language).then((data) => {
            this.UserResource
                .switchCoursyLocale({
                    coursyLanguage: this.language.toUpperCase(),
                    switchSourceType: this.USER_SWITCH_LANGUAGE_SOURCE_ENUM.KEYS.EVALUATION,
                    switchSourceGuid: this.$rootScope.formSubmission.guid
                })
                .$promise
                .then(() => {
                    this.$rootScope.$emit('evaluation:language', data);
                });
        });
        this.initData();
    }

    initData () {
        this.FormSubmissionResource.get({
            guid: this.$stateParams.guid,
            expand: 'form,evaluation',
            _lang: this.language
        }).$promise.then(data => {
            this.submission = data;
            this.CompanyResource.publicView({ id: this.submission.companyId, expand: 'companyI18ns,languages' }).$promise.then(company => {
                this.company = company;
                this.languages = company.languages.map(language => language.language);
            });
            this.evaluatee = data.evaluation ? `${data.evaluation.evaluableFirstName} ${data.evaluation.evaluableLastName}` : '';
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/header/evaluation/evaluation/index.js